export default __webpack_public_path__ + "static/media/safety.0a7954b6.png";